import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class RoadmapTableInitiativePlanningWeeksRoute extends Route {
  model() {
    return this.modelFor('backlog.initiatives.initiative');
  }
}

export default instrumentRoutePerformance(
  RoadmapTableInitiativePlanningWeeksRoute,
);
